import axiosInstance from '../config/axios.js';

const API_BASE = '/dry-box-surveys';

const dryBoxSurveyService = {
  // Get all dry box surveys with optional filters and pagination
  getAll: async (page = null, perPage = 10, params = {}) => {
    const queryParams = page !== null
      ? { page, per_page: perPage, ...params }
      : { all: 'true', ...params };
    const response = await axiosInstance.get(API_BASE, { params: queryParams });
    return response.data;
  },

  // Get all dry box surveys without pagination
  getAllSurveys: async (params = {}) => {
    const queryParams = {
      all: 'true',
      ...params
    };
    const response = await axiosInstance.get(API_BASE, { params: queryParams });
    return response.data;
  },

  // Get client published dry box surveys (for clients)
  getClientSurveys: async (clientId, page = 1, perPage = 10, params = {}) => {
    const queryParams = {
      client_id: clientId,
      page,
      per_page: perPage,
      ...params
    };
    const response = await axiosInstance.get(`${API_BASE}/client`, { params: queryParams });
    return response.data;
  },

  // Get dry box survey by ID
  getById: async (surveyId) => {
    const response = await axiosInstance.get(`${API_BASE}/${surveyId}`);
    return response.data;
  },

  // Create new dry box survey
  create: async (surveyData) => {
    const response = await axiosInstance.post(API_BASE, surveyData);
    return response.data;
  },

  // Update dry box survey
  update: async (surveyId, surveyData) => {
    const response = await axiosInstance.put(`${API_BASE}/${surveyId}`, surveyData);
    return response.data;
  },

  // Toggle published status
  togglePublished: async (surveyId) => {
    const response = await axiosInstance.patch(`${API_BASE}/${surveyId}/toggle-published`);
    return response.data;
  },

  // Delete dry box survey
  delete: async (surveyId) => {
    const response = await axiosInstance.delete(`${API_BASE}/${surveyId}`);
    return response.data;
  },

  // Generate certificate
  generateCertificate: async (surveyId) => {
    const response = await axiosInstance.get(`${API_BASE}/${surveyId}/certificate`, {
      responseType: 'blob'
    });
    return response.data;
  },

  // Get pending surveys for DM
  getPendingForDM: async (page = 1, perPage = 10, params = {}) => {
    const queryParams = {
      page,
      per_page: perPage,
      ...params
    };
    const response = await axiosInstance.get(`${API_BASE}/pending-for-dm`, { params: queryParams });
    return response.data;
  },

  // Send bulk email for selected surveys
  sendBulkEmail: async (surveyIds) => {
    const response = await axiosInstance.post(`${API_BASE}/send-bulk-email`, {
      ids: surveyIds
    });
    return response.data;
  },

  // Download bulk PDFs for selected surveys (single PDF or ZIP)
  downloadBulkPDF: async (surveyIds) => {
    const response = await axiosInstance.post(`${API_BASE}/bulk-pdf-download`, {
      ids: surveyIds
    }, {
      responseType: 'blob'
    });
    return response;
  },

  // Export CSV for selected surveys
  exportCSV: async (surveyIds) => {
    const response = await axiosInstance.post(`${API_BASE}/export-csv`, {
      ids: surveyIds
    }, {
      responseType: 'blob'
    });
    return response.data;
  },

  // Duplicate a dry box survey record
  duplicate: async (surveyId) => {
    const response = await axiosInstance.post(`${API_BASE}/${surveyId}/duplicate`);
    return response.data;
  },
};

export default dryBoxSurveyService;